import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import { Link, useParams } from "react-router-dom";
// Import the Loader component
import request from "../../Apis/request";
import ReactPaginate from "react-paginate"; // Import ReactPaginate
import "../Chargers/Charger.css";
import Loader from "../Chargers/Loader";
import "../Meters/Meter.css";
import { fetchStatusList } from "../../Apis/StatusListing";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Select from "react-select";

const Add = () => {
  document.title = "RFID Offers ";
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [userStatuses, setUserStatuses] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("");
  const [stationList, setStationList] = useState([]);
  const [selectedchargerType, setselectedchargerType] = useState([]);
  const [selectedRfID, setSelectedRfID] = useState([]);
  const [StationData, setStationData] = useState([]);
  const [selectedchargerEmi, setSelectedChargerEmi] = useState("");
  const [selectedstation_id, setselectedstation_id] = useState("");
  const [RFIDlisting, setRFIDlisting] = useState([]);
  const [startRange, setStartRange] = useState(""); // Starting index for range
  const [endRange, setEndRange] = useState(50);

  let navigate = useNavigate();

  const fetchRfid = async () => {
    setLoading(true);
    const apiUrl = `${BaseURL}/rfid-offer`;
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      console.log("response", response);
      setRFIDlisting(response.data || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchRfid();
  }, []);

  const stationOptions = StationData?.map((item) => ({
    value: item?._id, // Value combines IMEI and ID
    label: item?.station_name, // Display the IMEI number
  }));
  const RfidOptons = RFIDlisting?.map((rfid) => ({
    value: rfid._id,
    label: rfid?.serial_number,
  }));
  const limitedOptions = RfidOptons.slice(startRange, endRange);

  // Function to handle the change event when multiple options are selected
  const handleRfidChange = (selectedOptions) => {
    if (Array.isArray(selectedOptions)) {
      const selectedRfIDs = selectedOptions.map(option => option.value);
      setSelectedRfID(selectedRfIDs); // Update selected values
    } else {
      setSelectedRfID([]); // Clear selection if no options are selected
    }
  };
  const SelectLimitChange = (e) => {
    setStartRange(e.target.value);
  }

  const SelectRangeChange = (e) => {
    
    setEndRange(e.target.value);
    

    const startRangeId = startRange;
    const endRangeId = e.target.value;

    const filteredArray = RFIDlisting.filter(item => 
      item._id >= startRangeId && item._id <= endRangeId
    );
    console.log("startRangeId", startRangeId, "endRangeId",endRangeId, "filteredArray", filteredArray);
    var selectedRFIds = [];
    for( var i=0; i < filteredArray.length; i++ ) {
      selectedRFIds.push(filteredArray[i]._id);
    }
    console.log(selectedRFIds);
    setSelectedRfID(selectedRFIds);

  }



  const fetchStations = async () => {
    setLoading(true);
    const apiEndpoint = `${BaseURL}/station`;

    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      console.log("stationDataaaa", response);
      setStationData(response.data.data || []);
    } catch (error) {
      console.error("Error fetching ChargerData:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStations();
  }, []);
  console.log("stations", StationData);

  useEffect(() => {
    const ChargingTypesData = async () => {
      setLoading(true);
      const apiEndpoint = `${BaseURL}/master/ac-0,dc-0`;
      try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });

        setStationList(response?.data?.data);
      } catch (error) {
        // console.error("Error fetching countries:", error);
      } finally {
        setLoading(false);
      }
    };

    ChargingTypesData();
  }, []);

  const handleAssignStation = async (e) => {
    e.preventDefault();
    const url = `${BaseURL}/rfid-offer/assign-station`;
    const statusData = {
      station_id: selectedstation_id,
      rfids: selectedRfID,
    };
    try {
      // Send status as JSON instead of FormData
      const response = await axios.put(url, statusData, {
        headers: {
          "Content-Type": "application/json", // Send as JSON
          Authorization: `Bearer ${uniqueToken}`,
          Method: "PUT",
        },
      });

      // Handle the response
    if (response.data.statusCode === 200) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: response?.data?.message,
            showConfirmButton: false,
            timer: 1500,
          });
          navigate(`/rfid-record/rfid-list`);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: `Failed to update station. Status: ${response.data.statusCode}`,
          });
        }
      } catch (error) {
        // Hide the loader
        Swal.close();
    
        console.error("Error in AddCharger:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.message || "An unexpected error occurred.",
        });
      }
  };
  const handlechargerType = (e) => {
    setselectedchargerType(e.target.value);
  };
  const handleStationChange = (selectedOption) => {
    if (selectedOption) {
      // setPage(1);
      setselectedstation_id(selectedOption.value);
    } else {
      setSelectedChargerEmi(null);
      // setSelectedChargerID(null);
    }
  };
  const handleReset = (e) => {
    e.preventDefault();
    navigate("/rfid-record/rfidoffer-add");
  };

  console.log("RFIDlisting", RFIDlisting);
  console.log("selectedRfID", selectedRfID);
  console.log("selectedstation_id", selectedstation_id);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="portlet-body mx-3">
              <div className="d-flex align-items-center">
                <h4 className="mb-0" style={{ marginRight: "10px" }}>
                  Add RFID
                </h4>
              </div>
              <hr style={{ marginTop: "5px" }} />
              <div className="row">
                <div className="col-12">
                  <form
                    className="form-horizontal"
                    role="form"
                    method="post"
                    style={{ marginTop: "5px" }}
                  >
                    <div className="row px-3">
                      {/* Flexbox container to align inputs side by side */}
                      <div className="col-12">
                        <div className="form-group d-flex flex-wrap align-items-center justify-content-start">
                          {/* First Dropdown: Select Station */}
                          <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                            <Select
                              options={stationOptions} // Pass the options array
                              onChange={handleStationChange} // Handle selection
                              placeholder="Select Station"
                              isClearable
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  height: "38px", // Ensuring same height for dropdowns
                                  minWidth: "200px",
                                  maxWidth: "250px",
                                }),
                              }}
                            />
  
                            <select
                              className="form-control"
                              style={{ minWidth: "200px", maxWidth: "250px" }}
                              onChange={SelectLimitChange}
                            >
                              <option value="">Start Range</option>
                              {RFIDlisting &&
                                RFIDlisting.map((u) => (
                                  <option key={u?._id} value={u?._id}>
                                    {u?.serial_number}
                                  </option>
                                ))}
                            </select>
  
                            <select
                              className="form-control"
                              style={{ minWidth: "200px", maxWidth: "250px" }}
                              onChange={SelectRangeChange}
                            >
                              <option value="">End Range</option>
                              {RFIDlisting &&
                                RFIDlisting.map((u) => (
                                  <option key={u?._id} value={u?._id}>
                                    {u?.serial_number}
                                  </option>
                                ))}
                            </select>
  
                            <Select
                              isMulti // Allow multiple selections
                              value={RfidOptons.filter((option) =>
                                selectedRfID.includes(option.value)
                              )}
                              onChange={handleRfidChange}
                              options={RfidOptons}
                              placeholder="Select RFID"
                              isClearable
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  boxShadow: "none",
                                  minWidth: "200px",
                                  maxWidth: "250px",
                                }),
                              }}
                            />
                          </div>
  
                          {/* Submit and Reset Buttons (side by side) */}
                          <div class="col-2" style={{ display: "flex", gap: "10px", marginTop:"-8px" }}>
                            <button
                              type="submit"
                              onClick={handleAssignStation}
                              className="btn btn-primary"
                              style={{
                                height: "38px", // Same height as the other elements
                                lineHeight: "20px",
                              }}
                            >
                              Submit
                            </button>
  
                            <button
                              type="input"
                              onClick={handleReset}
                              className="btn btn-primary"
                              style={{
                                height: "38px", // Same height as the other elements
                                lineHeight: "20px",
                              }}
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
  
};

export default Add;
